// extracted by mini-css-extract-plugin
export default {"container":"_404_container__zVGZy","wrapper":"_404_wrapper__QIinq","button":"_404_button__NHFoN"};